//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useRouter } from '@core/utils'
import { useResponsiveLeftSidebar } from '@core/comp-functions/ui'
import {
  mdiMenu,
  mdiMagnify,
  mdiChevronRight,
  mdiChevronLeft,
  mdiTrashCanOutline,
  mdiStarOutline,
  mdiStar,
  mdiReload,
  mdiDotsVertical,
  mdiFolderOutline,
  mdiEmailOutline,
  mdiEmailOpenOutline,
  mdiLabelOutline,
  mdiAttachment,
  mdiAlertOctagonOutline,
} from '@mdi/js'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

// Store
// eslint-disable-next-line object-curly-newline
import { ref, onUnmounted, computed, watch } from '@vue/composition-api'
import { formatDateToMonthShort } from '@core/utils/filter'
import store from '@/store'
import useEmail from './useEmail'
import emailStoreModule from './emailStoreModule'

// Local Componnets
import EmailLeftSidebarContent from './EmailLeftSidebarContent.vue'
import EmailView from './EmailView.vue'

export default {
  components: {
    EmailLeftSidebarContent,
    EmailView,

    // 3rd Party
    PerfectScrollbar,
  },
  setup() {
    // ————————————————————————————————————
    //* ——— Store Registration
    // ————————————————————————————————————

    const EMAIL_APP_STORE_MODULE_NAME = 'app-email'

    // Register module
    if (!store.hasModule(EMAIL_APP_STORE_MODULE_NAME)) {
      store.registerModule(EMAIL_APP_STORE_MODULE_NAME, emailStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(EMAIL_APP_STORE_MODULE_NAME)) store.unregisterModule(EMAIL_APP_STORE_MODULE_NAME)
    })

    // ————————————————————————————————————
    //* ——— Left Sidebar
    // ————————————————————————————————————

    const { isLeftSidebarOpen, contentStyles } = useResponsiveLeftSidebar({ sidebarWidth: 260 })

    // ————————————————————————————————————
    //* ——— Router
    // ————————————————————————————————————

    const { route, router } = useRouter()

    // Search Query & Route Params
    const searchQuery = computed({
      get: () => route.value.query.q,
      set: val => {
        const currentRouteQuery = JSON.parse(JSON.stringify(route.value.query))

        if (val) currentRouteQuery.q = val
        else delete currentRouteQuery.q

        router.replace({ name: route.name, query: currentRouteQuery })
      },
    })
    const routeParams = computed(() => route.value.params)

    // Fetch email again of search query change or route param change
    // eslint-disable-next-line no-use-before-define
    watch([searchQuery, routeParams], () => fetchEmails())

    // ————————————————————————————————————
    //* ——— useEmail
    // ————————————————————————————————————

    const { resolveLabelColor, moveToFolderMenuListItems, updateLabelMenuListItems } = useEmail()

    // ————————————————————————————————————
    //* ——— Emails & Email Meta
    // ————————————————————————————————————

    // Emails & Emails Meta
    const emails = ref([])
    const emailsMeta = ref({})

    const fetchEmails = () => {
      store
        .dispatch('app-email/fetchEmails', {
          q: searchQuery.value,
          folder: router.currentRoute.params.folder || 'inbox',
          label: router.currentRoute.params.label,
        })
        .then(response => {
          emails.value = response.data.emails
          emailsMeta.value = response.data.emailsMeta
        })
    }

    fetchEmails()

    // ————————————————————————————————————
    //* ——— Mail Selection
    // ————————————————————————————————————

    const selectedEmails = ref([])
    const toggleSelectedMail = mailId => {
      const mailIndex = selectedEmails.value.indexOf(mailId)

      if (mailIndex === -1) selectedEmails.value.push(mailId)
      else selectedEmails.value.splice(mailIndex, 1)
    }
    const selectAllEmailCheckbox = computed(
      () => emails.value.length && emails.value.length === selectedEmails.value.length,
    )
    const isSelectAllEmailCheckboxIndeterminate = computed(
      () => Boolean(selectedEmails.value.length) && emails.value.length !== selectedEmails.value.length,
    )
    const selectAllCheckboxUpdate = val => {
      selectedEmails.value = val ? emails.value.map(mail => mail.id) : []
    }
    const isAllSelectedMailAreRead = computed(() => {
      // Get array of isRead property value from selected mails array
      const emailsIsRead = selectedEmails.value.map(emailId => emails.value.find(email => email.id === emailId).isRead)

      // Return icon based on selection
      return emailsIsRead.every(emailIsRead => emailIsRead)
    })

    // ? Watcher to reset selectedEmails is somewhere below due to watch dependecy fullfilment

    // ————————————————————————————————————
    //* ——— Mail Actions
    // ————————————————————————————————————

    const toggleStarred = email => {
      store
        .dispatch('app-email/updateEmail', {
          emailIds: [email.id],
          dataToUpdate: { isStarred: !email.isStarred },
        })
        .then(() => {
          // eslint-disable-next-line no-param-reassign
          email.isStarred = !email.isStarred
        })
    }

    const moveSelectedEmailsToFolder = (folder, emailIds = selectedEmails.value) => {
      store
        .dispatch('app-email/updateEmail', {
          emailIds,
          dataToUpdate: { folder },
        })
        .then(() => {
          fetchEmails()
        })
        .finally(() => {
          selectedEmails.value = []
        })
    }

    const updateSelectedEmailsLabel = label => {
      store
        .dispatch('app-email/updateEmailLabels', {
          emailIds: selectedEmails.value,
          label,
        })
        .then(() => {
          fetchEmails()
        })
        .finally(() => {
          selectedEmails.value = []
        })
    }

    const markSelectedEmailsAsUnread = (emailIds = selectedEmails.value) => {
      store
        .dispatch('app-email/updateEmail', {
          emailIds,
          dataToUpdate: { isRead: false },
        })
        .then(() => {
          fetchEmails()
        })
        .finally(() => {
          selectedEmails.value = []
        })
    }

    const markSelectedEmailsAsRead = (emailIds = selectedEmails.value) => {
      store
        .dispatch('app-email/updateEmail', {
          emailIds,
          dataToUpdate: { isRead: true },
        })
        .then(() => {
          fetchEmails()
        })
        .finally(() => {
          selectedEmails.value = []
        })
    }

    // ————————————————————————————————————
    //* ——— Email View
    // ————————————————————————————————————

    const isEmailDetailsOpen = ref(false)
    const emailViewData = ref({})
    const opendedEmailMeta = computed(() => {
      const openedEmailIndex = emails.value.findIndex(e => e.id === emailViewData.value.id)

      return {
        hasNextEmail: Boolean(emails.value[openedEmailIndex + 1]),
        hasPreviousEmail: Boolean(emails.value[openedEmailIndex - 1]),
      }
    })
    const updateEmailViewData = email => {
      // Mark email is read
      store
        .dispatch('app-email/updateEmail', {
          emailIds: [email.id],
          dataToUpdate: { isRead: true },
        })
        .then(() => {
          // If opened email is unread then decrease badge count for email meta based on email folder
          if (!email.isRead && (email.folder === 'inbox' || email.folder === 'spam')) {
            emailsMeta.value[email.folder] -= 1
          }

          // eslint-disable-next-line no-param-reassign
          email.isRead = true
        })
        .finally(() => {
          emailViewData.value = email
          isEmailDetailsOpen.value = true
        })
    }
    const moveOpenEmailToFolder = folder => {
      selectedEmails.value = [emailViewData.value.id]
      moveSelectedEmailsToFolder(folder)
      selectedEmails.value = []
      isEmailDetailsOpen.value = false
    }
    const updateOpenEmailLabel = label => {
      selectedEmails.value = [emailViewData.value.id]
      updateSelectedEmailsLabel(label)

      // Update label in opened email
      const labelIndex = emailViewData.value.labels.indexOf(label)
      if (labelIndex === -1) emailViewData.value.labels.push(label)
      else emailViewData.value.labels.splice(labelIndex, 1)

      selectedEmails.value = []
    }

    const markOpenEmailAsUnread = () => {
      selectedEmails.value = [emailViewData.value.id]
      markSelectedEmailsAsUnread()

      selectedEmails.value = []
      isEmailDetailsOpen.value = false
    }

    const changeOpenedEmail = dir => {
      const openedEmailIndex = emails.value.findIndex(e => e.id === emailViewData.value.id)
      const newEmailIndex = dir === 'previous' ? openedEmailIndex - 1 : openedEmailIndex + 1
      emailViewData.value = emails.value[newEmailIndex]
    }

    // * If someone clicks on filter while viewing detail => Close the email detail view
    watch(routeParams, () => {
      isEmailDetailsOpen.value = false
    })

    // * Watcher to reset selectedEmails
    // ? You can also use isEmailDetailsOpen (instead of `emailViewData`) but it will trigger execution twice in this case
    // eslint-disable-next-line no-use-before-define
    watch([emailViewData, routeParams], () => {
      selectedEmails.value = []
    })

    // ————————————————————————————————————
    //* ——— Compose
    // ————————————————————————————————————

    const isEmailComposeDialogVisible = ref(false)

    // ————————————————————————————————————
    //* ——— Perfect Scrollbar
    // ————————————————————————————————————

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      isLeftSidebarOpen,
      contentStyles,

      // Search Query
      searchQuery,

      // EMails & EMail Meta
      emails,
      emailsMeta,
      fetchEmails,

      // Mail Selection
      selectedEmails,
      toggleSelectedMail,
      selectAllEmailCheckbox,
      isSelectAllEmailCheckboxIndeterminate,
      selectAllCheckboxUpdate,
      isAllSelectedMailAreRead,

      // Mail Actions
      toggleStarred,
      moveSelectedEmailsToFolder,
      updateSelectedEmailsLabel,
      markSelectedEmailsAsUnread,
      markSelectedEmailsAsRead,

      // EMail View
      isEmailDetailsOpen,
      emailViewData,
      opendedEmailMeta,
      updateEmailViewData,
      moveOpenEmailToFolder,
      updateOpenEmailLabel,
      markOpenEmailAsUnread,
      changeOpenedEmail,

      // Compose
      isEmailComposeDialogVisible,

      // useEmail
      resolveLabelColor,
      moveToFolderMenuListItems,
      updateLabelMenuListItems,

      // Perfect Scrollbar
      perfectScrollbarSettings,

      // Filter/Formatter
      formatDateToMonthShort,

      // Icons
      icons: {
        mdiMenu,
        mdiMagnify,
        mdiChevronRight,
        mdiChevronLeft,
        mdiTrashCanOutline,
        mdiReload,
        mdiDotsVertical,
        mdiStarOutline,
        mdiStar,
        mdiFolderOutline,
        mdiEmailOutline,
        mdiEmailOpenOutline,
        mdiLabelOutline,
        mdiAttachment,
        mdiAlertOctagonOutline,
      },
    }
  },
}
